import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonLevel } from '../tarifications.component';
import { ExpandableRadioButtonComponent } from '../expandable-radio-button/expandable-radio-button.component';
import { LanguageStore } from '../../../shared/services/language.store';
import { ACS_WARRANTY_TABLE_LINK_EN, ACS_WARRANTY_TABLE_LINK_FR } from '../../../shared/helpers/constants';

@Component({
  selector: 'acs-medical-care-option-section',
  imports: [
    MatRadioGroup,
    TranslatePipe,
    MatRadioButton,
    ReactiveFormsModule,
    ExpandableRadioButtonComponent
  ],
  templateUrl: './medical-care-option-section.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicalCareOptionSectionComponent {
  @Input({ required: true }) fc!: FormControl;
  @Input({ required: true }) options!: RadioButtonLevel[];

  #languageStore = inject(LanguageStore);
  get guaranteesTableLink() { return this.#languageStore.currentLanguageCode() === 'fr' ? ACS_WARRANTY_TABLE_LINK_FR : ACS_WARRANTY_TABLE_LINK_EN; }

  expandedOption: number | null = null;

  expandPanel(optionNb: number) {
    this.expandedOption = this.expandedOption === optionNb ? null : optionNb;
  }
}
